import React from 'react';

import { Grid, css, Header, theme, Button, Div } from "@bdfx/fukit"
import trans from "../trans"
import ctrans from "../../common/trans"
import {Doughnut} from "react-chartjs-2"
import {formatInt, formatPNO} from "../../common/format"
import history from '../../common/history'
import ExportButton from "./export-button"
import { getProblemUrl } from '../helpers';

const ResultLine = ({auditId, index, count, total, type, background = "#fff"}) => {
    
    const getData = ({
        labels: [
            ctrans("found_products"), trans("group_ok"),
        ],
        datasets: [{
            data: [count, total-count],
            backgroundColor: [background, theme.green_raw],
            borderWidth: 5,
            // hoverBorderWidth: 1,
            hoverBorderColor: "white",
            borderColor: "white",
    
        }],
    })

    const getOptions = ({
        cutoutPercentage: 72,
        plugins: {
            datalabels: {
              display: false,
            },
        },
        legend: {
            display: false,
        },
    })

    // const issueRatio = count / (total - count)
    const issueRatio = count / (total)

    const detailButtonHref = getProblemUrl(auditId, index);

    const handleDetailButtonClick = (e) => {
        e.preventDefault()
        history.push(detailButtonHref)
        e.stopPropagation()
        return false;
    }
    
    return (
        <StyledGrid cols="150px 1fr auto" gap="50px" valign="center"  className="npbreak">
            <Div position="relative" textAlign="center" className="graph">
                <Doughnut width={150} height={150} data={getData} options={getOptions} />
                <Div className="count" color={background}>
                    <span>{formatInt(count)}</span>
                    <br/>
                    <span style={{color: "#666", fontSize: "14px"}}>
                        {formatPNO(Math.round(issueRatio * 100))}
                    </span>
                    
                    </Div>
            </Div>

            <Div>
                <Header type={4}>{trans(index)}</Header>
                <p>{trans(index+"_info")}</p>
            </Div>

            <Div whiteSpace="nowrap" className="buttons">
                <Button secondary={true} as={"a"} 
                    href={detailButtonHref} 
                    onClick={handleDetailButtonClick}
                    color="#3c3c3c" 
                    size="small" 
                    icon="chevron-right-light"
                >
                    Detail
                </Button>
                <ExportButton auditId={auditId} index={index} />
            </Div>
        </StyledGrid>
    )
}


const StyledGrid = css(Grid)({

    "@media only screen and (max-width: 1000px)": {
        display: "block",
        ".graph": {
            maxWidth: "150px",
            margin: "auto",
        },
        ".fuk-button": {
            display: "inline-block !important",
            margin: "0 10px",
        },
        ".buttons": {
            marginTop: "-20px",
            textAlign: "right"
        },
        ".fuk-header": {
            marginLeft: "1em",
            marginBottom: "-20px",
        },
    },

    padding: "25px 0",
    borderBottom: "1px solid #a8a8a8",
    ":last-child": {
        borderBottom: "none",
    },
    ".count": {
      fontSize: "28px",
      position: "absolute",
      left: "0",
      right: "0",
      top: "50%",
      fontWeight: "bold",
      transform: "translate3d(0,-50%,0)",
    },
    ".fuk-button": {
        display: "block",
        "& + .fuk-button": {
            marginTop: "20px",
        }
    },
    "p": {
        fontSize: "1.35em",
    },
})

export default ResultLine